module.exports = __webpack_public_path__ + "static/media/pdf-icoin.ccd5038b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf-icoin.png
// module id = ./src/assets/pdf-icoin.png
// module chunks = 0